import React, { useState, useEffect } from "react";

const SearchBar = ({ legends, filterViaSearchBar, setShowSearched, handleQueryValue }) => {
  const [queryValue, setQueryValue] = useState("");
  var prodType =
    location.href.indexOf("roll-up") > -1
      ? "roll-up sign"
      : location.href.indexOf("overlay") > -1
      ? " sign overlay"
      : "";
  var needALegend =
    prodType === "" ? "" : "Need a legend for your " + prodType + "?";

  const handleInputChange = (event) => {
    const query = event.target.value;
    setQueryValue(query);
    handleQueryValue(query)
  };

  useEffect(() => {
    if (queryValue != "") {
      const results = searchItems(queryValue);
      filterViaSearchBar(results.length > 0 ? results : null);
      setShowSearched(true);

    } else {
      setShowSearched(false);
    }
  }, [queryValue]);

  const searchItems = () => {
    let results = [];
    let searchTerm = queryValue.toLowerCase().trim();

    Object.values(legends).filter((legend) => {
      let legendItems = legend;
      legendItems.filter((legendItem) =>
        // Use a recursive helper function to search within each legend

        containsString(legendItem, searchTerm) > 0 ? results.push(legend) : ""
      );
      // console.log(match)
      // match.length > 0 ? results.push(match) : '';
    });
    // get rid of duplicates
    return [...new Set(results)];
  };

  // Helper function to search within an object
  const containsString = (obj, searchTerm) => {
    for (let key in obj) {
      if (obj[key] !== null && typeof obj[key] === "object") {
        // Recursively check nested objects
        if (containsString(obj[key], searchTerm)) return true;
      } else if (
        obj[key] &&
        obj[key].toString().toLowerCase().includes(searchTerm)
      ) {
        return true;
      }
    }
    return false;
  };

  return (
    <div className="panel-body">
      <div className="row search-box vertical-align">
        
      <img src="//media.trafficsafetystore.com/image/upload/images/newlegendview-hero-1920.webp" alt="hero image" />

      <div className="col-xs-12">
      <span>{needALegend}</span>
      </div>
        <div className="col-xs-12">
       
          <input
            type="text"
            placeholder="Type here to search below"
            value={queryValue}
            onChange={handleInputChange}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
